// © Microsoft Corporation. All rights reserved.

/** Cookie name to store user's consent for cookie wall. The cookie gets dropped when user gives consent */
export const cacCookieName = "cac";

/** Cookie name to store user's consent for MSCC cookie banner. The cookie gets dropped by MSCC framework when user gives consent */
export const msccCookieName = "MSCC";

/** Cookie name to store user's identity */
export const muidCookieName = "MUID";

/**
 * Cookie name to store user's consent for OneTrust cookie banner. The cookie gets dropped by OneTrust SDK when user gives consent.
 */
export const oneTrustConsentCookieName = "eupubconsent-v2";